<script setup>
import Index from "@/views/data/freezing/index.vue"

definePage({
  meta: {
    action: 'read',
    subject: 'data-freezing',
  },
})

const router = useRouter()

const tab = router.currentRoute.value.params.tab
</script>

<template>
  <Index :tab="tab" />
</template>
